import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "flex-column justify-center align-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Да")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Нет")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Продать")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Аннулировать")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Отправить билеты")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Отправить билеты")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Назад")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Нет данных")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogConfirm,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogConfirm) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogConfirm=false)),
          "max-width": "200",
          text: _ctx.dialogConfirmTitle
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_actions, { class: "flex-column my-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, { onClick: _ctx.onConfirm }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _hoisted_3,
                _createVNode(_component_v_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogConfirm = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["text"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogSelected,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogSelected) = $event)),
      disabled: _ctx.pending
    }, {
      default: _withCtx(() => [
        (_ctx.selectedOrder)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogSelected=false)),
              "max-width": "300",
              loading: _ctx.pending,
              disabled: _ctx.pending
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode("#" + _toDisplayString(_ctx.selectedOrder.id), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_subtitle, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Создан " + _toDisplayString(new Date(_ctx.selectedOrder.date).toLocaleString()), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedOrder.clientName) + " ", 1),
                    _hoisted_5,
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedOrder.clientTel) + " ", 1),
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(_ctx.selectedOrder.clientEmail), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode("Билетов: " + _toDisplayString(_ctx.selectedOrder.count) + " Сумма: " + _toDisplayString(_ctx.formatMoney(_ctx.selectedOrder.sum)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "text-body-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.selectedOrder.seats), 1)
                  ]),
                  _: 1
                }),
                (_ctx.selectedOrder.comment)
                  ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("Комментарий: " + _toDisplayString(_ctx.selectedOrder.comment), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card_actions, { class: "flex-column my-3" }, {
                  default: _withCtx(() => [
                    (_ctx.orderType==='reserve')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_v_btn, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sellReserve())),
                            class: "text-green-accent-4 my-1"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_7
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_btn, {
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteReserve())),
                            class: "text-red-accent-3 my-1"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          })
                        ], 64))
                      : (_ctx.orderType==='offline')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sendTickets())),
                            class: "text-green-accent-4 my-1"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          }))
                        : (_ctx.orderType==='online')
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 2,
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sendTickets())),
                              class: "text-green-accent-4 my-1"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_10
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogSelected=false))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"]),
    (_ctx.pending)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          class: "ma-5"
        }))
      : _createCommentVNode("", true),
    (_ctx.ordersData && Object.keys(_ctx.ordersData).length)
      ? (_openBlock(), _createBlock(_component_v_list, {
          key: 1,
          disabled: _ctx.pending,
          loading: _ctx.pending,
          class: "text-left align-self-start pl-4"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortByOrderId(_ctx.ordersData), (order) => {
              return (_openBlock(), _createBlock(_component_v_list_item, {
                key: order.id,
                onClick: ($event: any) => (_ctx.onClick(order))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(order.id) + ": " + _toDisplayString(order.clientName) + " " + _toDisplayString(order.clientTel), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_list_item_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formatMoney(order.sum)) + " " + _toDisplayString((new Date(order.date)).toLocaleString()), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_list_item_subtitle, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(order.seats), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_list_item_subtitle, { class: "text-blue-accent-1" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(order.comment), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
      : (_ctx.ordersData && !Object.keys(_ctx.ordersData).length)
        ? (_openBlock(), _createBlock(_component_v_card_text, { key: 2 }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
    _hoisted_13
  ]))
}